import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-shekel', 'CurrencyShekel', [["path",{"d":"M6 18v-12h4a4 4 0 0 1 4 4v4"}],["path",{"d":"M18 6v12h-4a4 4 0 0 1 -4 -4v-4"}]]);